import { useParams } from 'next/navigation';
import { useMemo } from 'react';

export const useOrgSlug = () => {
  const params = useParams();
  return useMemo(() => {
    const slug = params.orgSlug as string | undefined;
    if (slug == null) {
      return undefined;
    }
    return slug;
  }, [params]);
};
